// extracted by mini-css-extract-plugin
module.exports = {"head":"ClientBonusAllowancesTable__head---88n3","filter":"ClientBonusAllowancesTable__filter--3StHU"};